module.exports = __webpack_public_path__ + "static/media/hero-group.6f132b13.jpg";